<template>
  <div style="overflow-y: scroll; height: 100vh" class="content">
    <div class="root">
      <div class="p_title">Official data interpolation</div>
      <div class="p_content">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;National GDP PPP for 2005 were obtained from the WB-WDI first for the 189 countries provided. For 36 island countries like British Virgin Islands, Cayman Islands, Cook Islands and etc., where GDP were unavailable from WB-WDI, data were obtained from the Central Intelligence Agency (CIA) World Factbook (released in 2015). GDP in Taiwan (China), Nauru, and Syrian Arab Republic were from the International Monetary Fund (IMF, released in Oct 2017). GDP for the rest 11 countries were set as zero where no data to be found. All GDP data were presented in PPP in 2005 USD using conversion factors provided from the World Bank. The subnational GDP for China and the U.S. in 2005 were obtained the China Statistical Yearbooks and the BEA at state (or provincial) and county levels for validation and further updates. Meanwhile, census data were also obtained to calculate GDP per capita in order to spatially allocate global GDP. Meanwhile, global census at state level (1865 states with valid values) were obtained from World Bank as well.​
      </div>

      <div class="p_title p_title_top">Population-based GDP disaggregation</div>
      <div class="p_content">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Population can well capture the link between human capital and income growth in the econometric model, and broad literature has emphasized the role of human capital as a key driver of economic growth. It can be applied in spatial allocation of global GDP based on the LandScan population (Poppixel) and GDP per capital (Pcap, ratio of GDP to population totals in a given administrative boundary i, as control variable) to 1 km × 1 km grids (denote GDPPop).
      </div>
      <div style="text-align: center;"><img src="http://bunjs.aiside.top/2_1.png"/></div>

      <div class="p_title p_title_top">NTL-based GDP disaggregation</div>
      <div class="p_content">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        The satellite-derived NTL data has been proven to correlate well with GDP at all examined scales and has been widely used in spatial allocation of GDP over large areas. The DMSP-OLS NTL images in 2005 (average visible, stable lights, and cloud free coverages, satellites F14 and F15 simultaneously collected global NTL images and data from F15 was chosen as newer sensor would have less degradation of data quality) have been utilized to disaggregate global GDP to a spatial resolution of 30 arc seconds. Based on the theory that the GDP totals are directly distributed to each pixel in proportion to the DN values in a given administrative boundary, the NTL-Based GDP disaggregation (denoted GDPNTL) can be described as,

      </div>
      <div style="text-align: center;"><img src="http://bunjs.aiside.top/2-2.png"/></div>
      <div class="p_content">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        where GDPi is the GDP totals, SLi is the sum of DN values and GDPper_light is the constant in administrative unit i, DNpixel and GDPpixel are the DN value and corresponding GDP in each pixel in administrative unit i.
      </div>

      <div class="p_content">
        <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        The saturation problem in the DMSP-OLS NTL images, however, has resulted in overestimation in urban centers and underestimation in rural and distanced areas. Zhao et al., (2017) have improved its accuracy by incorporating the gridded population data into NTL-based GDP disaggregation in each pixel since population data has an exponential relationship with DN values of NTL images. By multiplying the NTL image with the LandScan population data in 2005, Lit-Pop image was produced and then used in Equation 3 to spatialize GDP at global scale (denoted GDPLit-Pop):
        <br/>
      </div>
      <div style="text-align: center;">
        <img src="http://bunjs.aiside.top/2-3.png"/>
      </div>

      <div class="p_content">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        where DNlp is the DN value of each pixel of Lit-Pop data, and SLPi is the sum of the DN values of Lit-Pop image in administrative unit i.
        <br/>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        The technical flow of mapping global GDP is shown in Figure 1.
      </div>
      <div style="text-align: center;">
        <img src="http://bunjs.aiside.top/2-4.png"/>
      </div>





    </div>
  </div>
</template>

<script>
  export default {
    name: "GDPDistribution"
  }
</script>

<style scoped>

  .root{
    width: 92%;
    margin: 2% 4%;
    background-color: white;
    text-align: center;
    font-family: "Calibri";
    padding-bottom: 100px;
  }

  .p_title{
    text-align: left;
    height: 50px;
    line-height: 50px;
    font-size: 2rem;
    font-weight: bold;
  }

  .p_title_top{
    margin-top: 25px;
    text-align: left;
  }

  .p_content{
    text-align: left;

    font-family: "Calibri";
    line-height: 40px;
    font-size: 2.2rem;
    font-weight: normal;
    color: black;
  }

  .content{
    line-height: 40px;
    font-size: 2.2rem;
    font-family: Calibri;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GDPDistribution.vue